import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/unified-dark.svg")